module.exports = __webpack_public_path__ + "static/media/carousel_lettuce_1.5bbd0c35.jpg";